// Module registry. Each module owns its routes and navigation entries; adding a module never
// requires editing the router. Views are lazy-loaded (code-split) on first visit.
import dashboard from './dashboard/routes.js';
import access from './access/routes.js';
import audit from './audit/routes.js';
import settings from './settings/routes.js';
import profile from './profile/routes.js';
import notifications from './notifications/routes.js';

export const modules = [dashboard, access, audit, settings, profile, notifications];

export const routes = modules.flatMap((m) => m.routes);

export const NAV_GROUPS = [
  { id: 'main', label: 'Workspace' },
  { id: 'admin', label: 'Administration' },
];

export const navItems = modules.flatMap((m) => m.nav ?? []).sort((a, b) => a.order - b.order);
